import React, { useContext } from 'react';
import NuevoProyecto from '../proyectos/NuevoProyecto';
import ListadoProyectos from '../proyectos/ListadoProyectos';
import proyectoContext from '../../context/proyectos/proyectoContext';
import AuthContext from '../../context/autenticacion/authContext';
import Swal from 'sweetalert2';

const Sidebar = () => {

    const authContext = useContext(AuthContext);
    const { usuario } = authContext;

    return (
        <aside>
            <h1>PCsNET <span>Tasks</span></h1>

            { usuario ? usuario.rol === 'Administrador' ? <NuevoProyecto /> : null : null }
            {/* <NuevoProyecto /> */}

            <div className="proyectos">
                <h2>Tus Proyectos</h2>

                <ListadoProyectos />
            </div>
            { usuario ? ( usuario.rol === 'Administrador' ? (
                <div className="proyectos-acciones">
                    <BotonEditar />
                    <BotonEliminar />
                </div>
            ) : null ) : null }
        </aside>
     );
}

const BotonEditar = () => {

    // Extraer proyectos de state inicial
    const proyectosContext = useContext(proyectoContext);
    const { proyecto, proyectoactivo, mostrarFormularioEditar } = proyectosContext;

    // Si no hay proyecto seleccionado
    if(!proyecto || !proyectoactivo) return null;

    return (
        <button
            type="button"
            className="btn btn-editar btn-block"
            onClick={() => mostrarFormularioEditar()}
        >Editar Proyecto &#8634;</button>
    )
}

const BotonEliminar = () => {

    // Extraer proyectos de state inicial
    const proyectosContext = useContext(proyectoContext);
    const { proyecto, proyectoactivo, eliminarProyecto } = proyectosContext;

    // Si no hay proyecto seleccionado
    if(!proyecto || !proyectoactivo) return null;

    // Array destructuring para extraer el proyecto actual
    const [ proyectoActual ] = proyecto;

    const confirmarEliminarProyecto = id => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: "Un tarea que se elimina no se puede recuperar.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2f3848',
            cancelButtonColor: '#be3434',
            confirmButtonText: 'Si, ¡eliminalo!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.value) {
                eliminarProyecto(id);
            }
        });
    }

    return (
        <button
            type="button"
            className="btn btn-eliminar btn-block"
            onClick={() => confirmarEliminarProyecto(proyectoActual._id)}
        >Eliminar Proyecto &#10007;</button>
    )
}

export default Sidebar;